<template>
  <div class="forgot">
    <div class="forgot__title">
      <p>Восстановление пароля</p>
      <span>Укажите email, и мы отправим ссылку для сброса пароля.</span>
    </div>
    <div>
      <input type="email" placeholder="Email" v-model="email" />
      <template v-for="(error) of v$.email.$errors" :key="error">
        <p class="errorValid">{{ error.$message }}</p>
      </template>
    </div>
    <button @click="submit" :disabled="loading">{{ loading ? 'Отправка...' : 'Отправить' }}</button>
    <router-link class="forgot__back" to="/">Вернуться ко входу</router-link>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, email as emailRule, helpers } from "@vuelidate/validators";
import { toast } from "vue3-toastify";
import { API_BASE_URL } from '@/config/api';

export default {
  name: 'ForgotPasswordView',
  data() {
    return {
      v$: useVuelidate(),
      email: '',
      loading: false,
    };
  },
  validations() {
    return {
      email: {
        required: helpers.withMessage('Обязательное поле', required),
        email: helpers.withMessage('Некорректный email', emailRule),
      },
    };
  },
  methods: {
    async submit() {
      this.v$.$validate();
      if (this.v$.$invalid) return;
      this.loading = true;
      try {
        const res = await this.$axios.post(`${API_BASE_URL}/password/forgot`, { email: this.email });
        toast.success(res.data?.message || 'Ссылка для сброса отправлена!');
      } catch (e) {
        const msg = e?.response?.data?.message || 'Не удалось отправить ссылку. Проверьте email.';
        toast.error(msg);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.errorValid {
  font-size: 10px !important;
  color: #FF2A62 !important;
}
.forgot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 120px;
  gap: 20px;
  &__title {
    text-align: center;
    font-weight: 700;
    font-size: 24px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    span {
      font-size: 12px;
      font-weight: 400;
      color: #909090;
    }
  }
  div {
    input {
      border-bottom: 1px solid #1F50F180 !important;
      border: none;
      outline: none;
      padding: 5px;
      &::placeholder {
        color: #90909080;
      }
      width: 100%;
    }
  }
  button {
    background: #1965EA;
    border: none;
    border-radius: 5px;
    color: white;
    padding: 7px 0px;
    width: 200px;
    cursor: pointer;
    &:hover {
      background: #1557c9;
      transition: all 0.3s ease;
    }
    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
  &__back {
    color: #1965EA;
    font-size: 12px;
  }
}
</style>
